import React from 'react';

const CropIcon = () => {
  return (
    <svg className="image-tool-button" width="22px" height="22px" viewBox="0 0 22 22" version="1.1" xmlns="http://www.w3.org/2000/svg" >
      <g id="Image-Splitting" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Missing-Image-Match---Image-Edit-Tooltip" transform="translate(-292.000000, -1113.000000)" fill="#262aff" fillRule="nonzero">
          <g id="Edit-Toolbar" transform="translate(283.000000, 1104.000000)">
            <g id="Crop">
              <g id="crop-regular-(1)" transform="translate(9.000000, 9.000000)">
                <path d="M21.3125,15.125 L17.875,15.125 L17.875,6.06933594 L21.7984766,2.14585937 C22.0670312,1.87730469 22.0670312,1.44203125 21.7984766,1.17347656 L20.8265234,0.201523438 C20.5579688,-0.06703125 20.1226953,-0.06703125 19.8541406,0.201523438 L15.9306641,4.125 L8.25,4.125 L8.25,6.875 L13.1806641,6.875 L6.875,13.1806641 L6.875,0.6875 C6.875,0.30765625 6.56734375,0 6.1875,0 L4.8125,0 C4.43265625,0 4.125,0.30765625 4.125,0.6875 L4.125,4.125 L0.6875,4.125 C0.30765625,4.125 0,4.43265625 0,4.8125 L0,6.1875 C0,6.56734375 0.30765625,6.875 0.6875,6.875 L4.125,6.875 L4.125,16.5 C4.125,17.2592578 4.74074219,17.875 5.5,17.875 L13.75,17.875 L13.75,15.125 L8.81933594,15.125 L15.125,8.81933594 L15.125,21.3125 C15.125,21.6923437 15.4326563,22 15.8125,22 L17.1875,22 C17.5673437,22 17.875,21.6923437 17.875,21.3125 L17.875,17.875 L21.3125,17.875 C21.6923437,17.875 22,17.5673437 22,17.1875 L22,15.8125 C22,15.4326563 21.6923437,15.125 21.3125,15.125 Z" id="Path" />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default CropIcon;
